"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _block_ai_learning = require("./block_ai_learning");
var _Svm = require(".././../class/learning/Svm");
module.exports = {
  getBlocks: function getBlocks() {
    var params = {
      getKernelOption: function getKernelOption() {
        var param = {
          type: 'DropdownDynamic',
          value: null,
          menuName: function menuName() {
            var value = this.getTargetValue('kernel');
            if (value === _Svm.KERNEL_STRING_TYPE.POLYNOMIAL) {
              return [[Lang.AiLearning.train_param_degree, 'degree']];
            } else if (value === _Svm.KERNEL_STRING_TYPE.RBF) {
              return [[Lang.AiLearning.train_param_gamma, 'gamma']];
            } else {
              return;
            }
          },
          needDeepCopy: true,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options.length) {
              return options[0][1];
            }
            return null;
          }
        };
        return param;
      }
    };
    return {
      learning_title_svm: {
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.template.learning_title_svm_str,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'learning_title_svm'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_svm'],
        events: {}
      },
      set_svm_option: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.train_param_C, 'C']],
          value: 'C',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number',
          value: _Svm.OPTION_DEFAULT_VALUE.C
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        def: {
          type: 'set_svm_option'
        },
        paramsKeyMap: {
          OPTION: 0,
          VALUE: 1
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_svm'],
        func: function func(sprite, script) {
          var option = script.getStringField('OPTION', script);
          var value = script.getNumberValue('VALUE', script);
          Entry.aiLearning.setTrainOption(option, parseFloat(value));
          return script.callReturn();
        },
        events: {},
        pyHelpDef: {
          params: [],
          type: 'set_svm_option'
        },
        syntax: {
          js: [],
          py: []
        }
      },
      set_kernel_linear: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null],
          type: 'set_kernel_linear'
        },
        pyHelpDef: {
          params: [],
          type: 'set_kernel_linear'
        },
        paramsKeyMap: {
          TEXT: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_svm'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var defaultValue;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  defaultValue = {
                    degree: 3,
                    gamma: 1
                  };
                  Entry.aiLearning.setTrainOption('kernel', 'linear');
                  Entry.aiLearning.setTrainOption('degree', defaultValue.degree);
                  Entry.aiLearning.setTrainOption('gamma', defaultValue.gamma);
                  return _context.abrupt("return", script.callReturn());
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      set_kernel_option: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.train_param_kernel_polynomial, _Svm.KERNEL_STRING_TYPE.POLYNOMIAL], [Lang.AiLearning.train_param_kernel_rbf, _Svm.KERNEL_STRING_TYPE.RBF]],
          value: 'polynomial',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          dropdownSync: 'kernel'
        }, params.getKernelOption(), {
          type: 'Block',
          accept: 'string',
          defaultType: 'number',
          value: _Svm.OPTION_DEFAULT_VALUE.degree
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        def: {
          type: 'set_kernel_option'
        },
        paramsKeyMap: {
          KERNEL: 0,
          OPTION: 1,
          VALUE: 2
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_svm'],
        func: function func(sprite, script) {
          // 초기화
          Entry.aiLearning.setTrainOption('gamma', _Svm.OPTION_DEFAULT_VALUE.gamma);
          Entry.aiLearning.setTrainOption('degree', _Svm.OPTION_DEFAULT_VALUE.degree);
          var kernel = script.getStringField('KERNEL', script);
          var option = script.getStringField('OPTION', script);
          var value = script.getNumberValue('VALUE', script);
          Entry.aiLearning.setTrainOption('kernel', kernel);
          Entry.aiLearning.setTrainOption(option, parseFloat(value));
          return script.callReturn();
        },
        events: {},
        pyHelpDef: {
          params: [],
          type: 'set_kernel_option'
        },
        syntax: {
          js: [],
          py: []
        }
      }
    };
  }
};